import { render, staticRenderFns } from "./LibraryFolderPermissions.vue?vue&type=template&id=6c10f567&"
import script from "./LibraryFolderPermissions.vue?vue&type=script&lang=js&"
export * from "./LibraryFolderPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports